import { useCallback, useEffect, useState } from 'react';

import { useMediaQuery } from '@mui/material';

import { MEDIA_QUERY } from '@/constants/media-query';

import { useSidebarStore } from '../stores';

export function useSidebarVisible() {
    const { isSidebarOpened, setIsSidebarOpened } = useSidebarStore();
    const isMobileSize = useMediaQuery(MEDIA_QUERY.ONLY_XS);

    const [isSidebarVisible, setIsSidebarVisible] = useState(isMobileSize ? false : isSidebarOpened);

    const setSidebarVisible = useCallback(
        (isOpened: boolean) => {
            if (!isMobileSize) {
                setIsSidebarOpened(isOpened);
            }

            setIsSidebarVisible(isOpened);
        },
        [isMobileSize, setIsSidebarOpened],
    );

    // NOTE: initial state or mobile-resize
    useEffect(() => {
        if (isMobileSize) {
            setIsSidebarVisible(false);
            return;
        }

        setIsSidebarVisible(isSidebarOpened);
        // NOTE: it only should check "isMobileSize" changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMobileSize]);

    return { isSidebarVisible, setSidebarVisible };
}
